export default class ResourceAccordion {
    constructor(context, settings, $) {
        // Environment variables
        this.context = context;
        this.settings = settings;
        this.$ = $;

        this.$heading = this.$('.js-resource-accordion-heading', this.context).once();
        this.$contentClass = this.$('.js-resource-accordion-content', this.context).once();

        this.$heading.on('click', $.proxy(this.toggleOpen, this));
    }

    toggleOpen(e) {
        const $elem = this.$(e.currentTarget);

        $elem.toggleClass('is-clicked').attr('aria-expanded', 'true');

        if (!$elem.hasClass('is-clicked')) {
            $elem.attr('aria-expanded', 'false');
            $elem.next('.js-resource-accordion-content').slideUp();
        } else {
            $elem.next('.js-resource-accordion-content').slideDown();
        }
    }
}
